import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Divider, Form, FormInput } from "semantic-ui-react";
import DateRangePicker from 'rsuite/DateRangePicker';
import 'rsuite/dist/rsuite-no-reset.min.css';
import moment from "moment/moment";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const VoucherAdd = () => {
    const navigate = useNavigate()
    const [aloc, setAloc] = useState('')
    const [tipe, setTipe] = useState('')
    const dateNow = new Date();
    const [date, setDate] = useState([
        new Date(),
        new Date(dateNow.setDate(dateNow.getDate() + 7))
    ])
    const [name, setName] = useState('')
    const [desc, setDesc] = useState('')
    const [code, setCode] = useState('')
    const [trx, setTrx] = useState(0)
    const [value, setValue] = useState(0)
    const [percent, setPercent] = useState(0)
    const [combine, setCombine] = useState('N')
    const [usageLimit, setUsageLimit] = useState('N')
    const [expose, setExpose] = useState('N')
    const [forSpecific, setForSpecific] = useState('N')
    const [minQty, setMinQty] = useState(1)
    const formatDateTime = (date) => {
        if (!date) return "";
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        const hours = String(date.getHours()).padStart(2, "0");
        const minutes = String(date.getMinutes()).padStart(2, "0");
        const seconds = String(date.getSeconds()).padStart(2, "0");

        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    };
    
    const [submitted, setSubmitted] = useState(false);
    const [loading, setLoading] = useState(false);


    const alocation = [
        {key:'M', text:'Member', value:'M'},
        {key:'C', text:'Customer', value:'C'},
    ]

    const type = [
        {key:'D', text:'Percent', value:'D'},
        {key:'N', text:'Nominal', value:'N'},
        {key: 'O', text: 'Ongkir', value: 'O'}
    ]

    const handleCheckExpose = (e) => { 
        if (e.checked){
            setExpose('Y')
        }else{
            setExpose('N')
        }
    }

    const handleCheckCombine = (e) => {
        if (e.checked) {
            setCombine("Y");
            setCombineWith((prev) => prev || "ongkir");
        } else {
            setCombine("N");
            setCombineWith("");
        }
    };
    
    const handleUsageLimit = (e) => {
        if (e.checked) {
            setUsageLimit("Y");
            setUsageLimitValue(0);
        } else {
            setUsageLimit("N");
            setUsageLimitValue(0);
        }
    };

    const handleCheckSpecific = (e) => { 
        if (e.checked){
            setForSpecific('Y')
        }else{
            setForSpecific('N')
        }
    }

    const handleSubmit = (e) => {
        e.preventDefault();

        setSubmitted(true);

        if (!aloc || !tipe || !desc) {
            return;
        }

        setLoading(true);

        const startDate = formatDateTime(date[0]);
        const endDate = formatDateTime(date[1]);
        const dateRange = [startDate, endDate];

        const final_combineWith = combine == "N" ? "N" : combineWith;

        const param = {
            alocation:aloc,
            tipe:tipe,
            // date_range:date,
            date_range:dateRange,
            name:name,
            description:desc,
            voucher_code:code,
            voucher_value: Number(value || 0),
            voucher_percent: Number(percent || 0),
            is_expose : expose,
            is_combine:combine,
            for_specific:forSpecific,
            minimum_trx:trx,
            minimum_qty:minQty,
            combineWith:final_combineWith,
            limit_usage:usageLimitValue,
        }
        
        
        axios({
            method:"POST",
            url:`${global.SRV}api_hoops_cms/controler/voucher.php/?index=2`,
            headers:{'Content-Type': 'text/plain'},
            data:param
        })
        .then(res => {
            if (res.data.state === 200){
                navigate('/voucher')
            }
        })
        .catch(error => {
            console.error(error);
        })
        .finally(() => {
            setLoading(false);
        });
    }

    const [combineWith, setCombineWith] = useState("ongkir");
    const [usageLimitValue, setUsageLimitValue] = useState('')

    const combineOptions = [
        {
            key: "ongkir",
            text: "Only with Ongkir",
            value: "ongkir",
        },
        {
            key: "any",
            text: "With Any Available Voucher",
            value: "any",
        },
    ];

    const handleSetTipe = (e) => {
        setTipe(e.value)
        setPercent(0)
        setValue(0)
    }
    
    return (
        <Container fluid>
            <Row className="mt-1 mb-3">
                <div className="text-facebook h3 mb-0"> Add Voucher</div>
                <div className="text-muted">Adding new voucher</div>
            </Row>
            <Divider />

            <Row className="d-flex justify-content-center mb-3 mt-3">
                <Col xl={6} lg={8} md={12} sm={12}>
                    <Form widths="equal" onSubmit={handleSubmit}>

                        {/* Voucher Code & Name */}
                        <Form.Group widths="equal" className="mb-3">
                            <Form.Input
                                type="text"
                                label="Voucher Code"
                                value={code}
                                //error={submitted && !code}
                                onChange={(e, { value }) => setCode(value)}
                            />

                            <Form.Input
                                type="text"
                                label="Voucher Name"
                                value={name}
                                onChange={(e, { value }) => setName(value)}
                            />
                        </Form.Group>

                        {/* Voucher Description */}
                        <Form.Field className="mb-3">
                            <Form.Input
                                type="text"
                                label="Voucher Description"
                                value={desc}
                                error={submitted && !desc}
                                onChange={(e, { value }) => setDesc(value)}
                            />
                        </Form.Field>

                        {/* Allocation & Type */}
                        <Form.Group widths="equal" className="mb-3">
                            <Form.Select
                                label="Allocation"
                                options={alocation}
                                value={aloc}
                                error={submitted && !aloc}
                                onChange={(e, { value }) => setAloc(value)}
                            />

                            <Form.Select
                                label="Type"
                                options={type}
                                value={tipe}
                                error={submitted && !tipe}
                                //onChange={(e, { value }) => setTipe(value)}
                                onChange={(e, value) => handleSetTipe(value)}
                            />
                        </Form.Group>

                        {/* Voucher Value */}
                        <Form.Group widths="equal" className="mb-3">

                            {/* Percent */}
                            {(tipe === "D" || tipe === "O") && (
                                <Form.Input
                                    type="number"
                                    label="Voucher Percent"
                                    value={percent}
                                    disabled={tipe === "O" && Number(value) > 0}
                                    onChange={(e, { value }) => setPercent(value)}
                                />
                            )}

                            {/* Nominal */}
                            {(tipe === "N" || tipe === "O") && (
                                <Form.Input
                                    type="number"
                                    label="Voucher Nominal"
                                    value={value}
                                    disabled={tipe === "O" && Number(percent) > 0}
                                    onChange={(e, { value }) => setValue(value)}
                                />
                            )}

                        </Form.Group>

                        {/* Minimum Transaction & Minimum Order Qty */}
                        <Form.Group widths="equal" className="mb-3">
                            <Form.Input
                                type="number"
                                label="Minimum Transaction"
                                defaultValue={0}
                                onChange={(e, { value }) => setTrx(value)}
                            />

                            <Form.Input
                                min={1}
                                max={10}
                                type="number"
                                label="Minimum Order Qty"
                                defaultValue={1}
                                onChange={(e, { value }) => setMinQty(value)}
                            />
                        </Form.Group>

                        {/* Voucher Options */}
                        <Form.Field className="mb-4">
                            <Form.Checkbox
                                label="Expose"
                                defaultChecked={false}
                                onChange={(e, data) => handleCheckExpose(data)}
                            />

                            <Form.Checkbox
                                label="For Specific Product"
                                defaultChecked={false}
                                onChange={(e, data) => handleCheckSpecific(data)}
                            />

                            <Form.Group
                                widths="equal" 
                            >
                                <Form.Field>
                                    <Form.Checkbox
                                        label="Combinable"
                                        defaultChecked={false}
                                        onChange={(e, data) => handleCheckCombine(data)}
                                    />
                                </Form.Field>

                                {combine === "Y" && (
                                    <Form.Field>
                                        <Form.Select
                                            options={combineOptions}
                                            value={combineWith}
                                            onChange={(e, { value }) => setCombineWith(value)}
                                        />
                                    </Form.Field>
                                )}
                            </Form.Group>

                            <Form.Group
                                widths="equal" 
                            >
                                <Form.Field>
                                    <Form.Checkbox
                                        label="Set Usage Limit"
                                        defaultChecked={false}
                                        onChange={(e, data) => handleUsageLimit(data)}
                                    />
                                </Form.Field>

                                {usageLimit === "Y" && (
                                    <Form.Input
                                        type="number"
                                        placeholder="Set maximum usage limit e.g. 100"
                                        value={usageLimitValue}
                                        onChange={(e, { value }) => setUsageLimitValue(value)}
                                    />
                                )}
                            </Form.Group>
                        </Form.Field>

                        {/* Active Date */}
                        <Form.Field className="mb-3">
                            <label>Active Date</label>

                            <DateRangePicker
                                defaultValue={date}
                                format="yyyy-MM-dd HH:mm:ss"
                                appearance="default"
                                size="lg"
                                style={{ width: "100%" }}
                                placement="topStart"
                                onOk={setDate}
                            />
                        </Form.Field>

                        {/* Submit */}
                        <Form.Field className="mb-3 mt-5">
                            <Form.Button
                                content={loading ? "Saving..." : "Save Voucher"}
                                color="facebook"
                                loading={loading}
                                disabled={loading}
                            />
                        </Form.Field>

                    </Form>
                </Col>
            </Row>

        </Container>
    )
}

export default VoucherAdd